export const incomeAndExpenditurePage = {
    heading: 'income-page-heading',
    body: 'income-page-body',
    formLink: 'income-form-link',
    callUsPhoneNumber: 'income-call-us-phone-number',
    authorityPhoneNumber: 'income-authority-phone-number',
    stepChangeLink: 'income-step-change-link',
    moneyWellnessLink: 'income-money-wellness-link',
};